var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.5 11.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0H1.5A1.5,1.5,0,0,0,0,1.5V9.75a1.5,1.5,0,0,0,1.5,1.5H15a1.5,1.5,0,0,0,1.5-1.5V1.5A1.5,1.5,0,0,0,15,0ZM1.5.75H15l.12,0L8.25,6.27,1.38.77Zm14.25,9a.76.76,0,0,1-.75.75H1.5a.76.76,0,0,1-.75-.75V1.5A.59.59,0,0,1,.8,1.27L8,7a.37.37,0,0,0,.46,0L15.7,1.27a.59.59,0,0,1,.05.23Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.7177084629f4c29e6be284307ec16024.svg";
export { ForwardRef as ReactComponent };